import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';

const Disposition = ({ description }) => (
	isEmpty(description) ? null : <span>{`${description}`}</span>
);
Disposition.propTypes = {
	code: PropTypes.string,
	description: PropTypes.string
};

export default Disposition;
